export default "__VITE_ASSET__DHXIx9rJ__"